import Dialog from "../../dialog/Dialog";
import { useState, useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  STATUS_DIALOG_WIDTH,
  StatusApprovalSection,
  StatusSettingsBody,
  StatusToggleRow,
} from "../../common/StatusSettingsParts";
import { attractionSettings } from "./service";

function to01(v) {
  if (v === true || v === 1 || v === "1") return 1;
  return 0;
}

function toApprovalTriState(v) {
  if (v === true || v === 1 || v === "1") return 1;
  if (v === 2 || v === "2") return 2;
  return 0;
}

const AttractionSettings = ({ open, onClose, attractionData, onNotify }) => {
  const queryClient = useQueryClient();
  const [status, setStatus] = useState({
    popular: to01(attractionData?.popular),
    is_approved: toApprovalTriState(attractionData?.is_approved),
    is_active:
      attractionData?.is_active === undefined || attractionData?.is_active === null
        ? 1
        : to01(attractionData.is_active),
    recommended: to01(attractionData?.recommended),
  });

  useEffect(() => {
    if (!open || !attractionData) return;
    setStatus({
      popular: to01(attractionData.popular),
      is_approved: toApprovalTriState(attractionData.is_approved),
      is_active:
        attractionData.is_active === undefined || attractionData.is_active === null
          ? 1
          : to01(attractionData.is_active),
      recommended: to01(attractionData.recommended),
    });
  }, [open, attractionData]);

  const handleToggle = (field) => {
    setStatus((prev) => ({
      ...prev,
      [field]: prev[field] === 1 ? 0 : 1,
    }));
  };

  const updateAttractionSettingsMutation = useMutation({
    mutationFn: () => attractionSettings(attractionData.id, status),
    onSuccess: () => {
      queryClient.invalidateQueries(["attractions"]);
      onNotify?.({
        message: "Attraction settings updated successfully",
        type: "success",
      });
      onClose();
    },
    onError: (error) => {
      const apiMessage = error.response?.data?.message;
      const validationErrors = error.response?.data?.errors;
      const message =
        (typeof apiMessage === "string" && apiMessage) ||
        (validationErrors &&
          Object.values(validationErrors).flat().join(", ")) ||
        error.message ||
        "Failed to update attraction settings";

      onNotify?.({
        message,
        type: "error",
      });
    },
  });

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        title="Attraction Status"
        width={STATUS_DIALOG_WIDTH}
        primaryButtonText="Save Changes"
        primaryButtonAction={() => updateAttractionSettingsMutation.mutate()}
        isLoading={updateAttractionSettingsMutation.isPending}
      >
        <StatusSettingsBody>
          <StatusToggleRow
            title="Popular Attraction"
            description="Show this attraction as popular"
            checked={status.popular === 1}
            onChange={() => handleToggle("popular")}
          />
          <StatusToggleRow
            title="Explore World Recommended"
            description="Mark this attraction as recommended by Explore World"
            checked={status.recommended === 1}
            onChange={() => handleToggle("recommended")}
          />
          <StatusApprovalSection
            value={status.is_approved}
            onChange={(value) =>
              setStatus((prev) => ({ ...prev, is_approved: value }))
            }
            description="Set the approval status for this attraction"
          />
          <StatusToggleRow
            title="Active Status"
            description="Attraction is active and visible to users"
            checked={status.is_active === 1}
            onChange={() => handleToggle("is_active")}
          />
        </StatusSettingsBody>
      </Dialog>
    </>
  );
};

export default AttractionSettings;
